import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { LoadingService } from 'src/app/_services/loading.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class BrandService {

  baseUrl = environment.baseUrl;

  brand_form = new FormGroup({
    id: new FormControl(null),
    brand_name: new FormControl('', [Validators.required]),
    slug: new FormControl(''),
    brand_desc: new FormControl(''),
    brand_img: new FormControl(null)
  });

  constructor(private http: HttpClient,
    private loading: LoadingService,) { }


  get_brands() {
    return this.http.get(this.baseUrl + '/get_brands');
  }

  /* Insert Brand */
  insert_brand(formData: any, brand_img: any) {
    //console.log(brand_img);
    var myFormData = new FormData();
    const headers = new HttpHeaders();
    headers.append('Content-Type', 'multipart/form-data');
    headers.append('Accept', 'application/json');
    myFormData.append('brand_name', formData.brand_name);
    // myFormData.append('brand_slug', formData.brand_slug);
    myFormData.append('brand_desc', formData.brand_desc);
    myFormData.append('brand_img', brand_img);
    myFormData.append('parent_brand_id', formData.parent_brand_id);
    //console.log(myFormData);
    return this.http.post(this.baseUrl + '/create_brand', myFormData, {
      headers: headers
    });
  }

  get_brand_id(brand_id) {
    return this.http.get(this.baseUrl + '/get_brand_id/' + brand_id);
  }

  /* Update Brand */
  update_brand(formData: any, brand_img: any) {
    var myFormData = new FormData();
    const headers = new HttpHeaders();
    headers.append('Content-Type', 'multipart/form-data');
    headers.append('Accept', 'application/json');
    myFormData.append('id', formData.id);
    myFormData.append('brand_name', formData.brand_name);
    // myFormData.append('brand_slug', formData.brand_slug);
    myFormData.append('brand_desc', formData.brand_desc);
    myFormData.append('brand_img', brand_img);
    myFormData.append('parent_brand_id', formData.parent_brand_id);
    return this.http.post(this.baseUrl + '/update_brand', myFormData, {
      headers: headers
    });
  }

  delete_brand(id: any) {
    return this.http.delete(this.baseUrl + '/delete_brand/' + id);
  }



}
